import { createApp } from 'vue';
import cmpFreebies from '../vue/Freebies.vue';

window.Freebies = (function(){
	const component = createApp(cmpFreebies, {});
	return component.mount('#component-freebies');
})();